import { defineAsyncComponent } from 'vue'
export default {
  "debug-clear": defineAsyncComponent(() => import("/opt/dist/app/layouts/debug-clear.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/dist/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/dist/app/layouts/empty.vue").then(m => m.default || m)),
  uikit: defineAsyncComponent(() => import("/opt/dist/app/layouts/uikit.vue").then(m => m.default || m))
}